import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import style from './event-card-skeleton.module.scss'

interface EventCardSkeletonProps extends HTMLProps<HTMLLIElement> {}

export const EventCardSkeleton = forwardRef<HTMLLIElement, EventCardSkeletonProps>((props, ref) => {
  const { className } = props

  return (
    <li className={clsx(className, style.container)} ref={ref}>
      <span className="skeleton" />
      <Text className={style.text} type="t1" color="dark" tagName="p">
        <span className="skeleton" />
      </Text>
    </li>
  )
})

EventCardSkeleton.displayName = 'EventCardSkeleton'
